"use strict";
exports.__esModule = true;
exports.AuthenticationTokenType = exports.AuthenticationType = void 0;
var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType["PASSWORD"] = "PASSWORD";
    AuthenticationType["TOKEN"] = "TOKEN";
})(AuthenticationType = exports.AuthenticationType || (exports.AuthenticationType = {}));
var AuthenticationTokenType;
(function (AuthenticationTokenType) {
    /** The app token is usually needed for programatic access from an external app using the API.
    * This token is usually long lasting as the app can reuse it for a long time without any renewal.
    */
    AuthenticationTokenType["APP"] = "APP";
})(AuthenticationTokenType = exports.AuthenticationTokenType || (exports.AuthenticationTokenType = {}));
